export enum EnterpriseOperatorsToCalcEnum {
    INCREASE = 'INCREASE',
    DECREASE = 'DECREASE',
}
